import { Link } from "react-router-dom";
import { categories } from "@/mocks/topics";

export default function CategoryGrid() {
  const list = categories.filter((c) => c.id !== "all");

  return (
    <section className="px-4 md:px-10 py-14 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">按主题找话题</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">热门内容按方向归好类,想看哪一类直接进。</p>
        </div>
        <Link to="/topics" className="text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap">
          查看全部话题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
        {list.map((c) => (
          <Link
            key={c.id}
            to={`/topics?category=${c.id}`}
            className="group flex flex-col p-5 rounded-lg bg-background-100 border border-background-200/80 hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors mb-4">
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <h3 className="font-heading font-semibold text-foreground-950 text-base">{c.name}</h3>
            <p className="text-xs text-foreground-500 mt-2 leading-relaxed flex-1">{c.desc}</p>
            <span className="text-xs text-foreground-600 mt-4 flex items-center gap-1.5">
              <i className="ri-file-list-3-line text-secondary-500"></i>
              {c.count} 条讨论
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}